import { Routes } from '@angular/router'

import { hasRoleGuard, isAuthenticatedGuard, isNotAuthenticatedGuard } from '@core/auth'
import { ROLES } from '@core/data/models'
import { RouteHeader } from '@core/navigation'
import { Layout } from '@layout/layout'

export const routes: Routes = [
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: '',
    component: Layout,
    canActivate: [isAuthenticatedGuard],
    children: [
      {
        path: '',
        title: 'Inicio',
        loadComponent: () => import('@pages/home-page/home-page').then(m => m.HomePage)
      },
      {
        path: 'profile',
        data: {
          header: {
            title: 'Mi perfil',
            description: 'Tu información, movimientos y ayuda',
            descriptionByRole: { [ROLES.EXECUTIVE]: 'Tu información, herramientas y ayuda' },
            image: 'https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/menu/perfil.png'
          } satisfies RouteHeader
        },
        loadComponent: () => import('@pages/profile-page/profile-page').then(c => c.ProfilePage)
      },
      {
        path: 'terms',
        title: 'Términos y condiciones',
        data: {
          header: {
            title: 'Términos y condiciones',
            description: 'Última actualización: 1 de septiembre de 2026',
            image: 'https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/Te%CC%81rminos+y+condiciones.png',
            back: true
          } satisfies RouteHeader
        },
        loadComponent: () => import('@pages/terms-page/terms-page').then(c => c.TermsPage)
      },
      {
        path: 'privacy',
        title: 'Aviso de privacidad',
        data: {
          header: {
            title: 'Aviso de privacidad',
            description: 'Cómo tratamos tus datos personales',
            image: 'https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/terms.png',
            back: true
          } satisfies RouteHeader
        },
        loadComponent: () => import('@pages/privacy-page/privacy-page').then(c => c.PrivacyPage)
      },
      {
        path: 'faq',
        title: 'Preguntas frecuentes',
        data: {
          header: {
            title: 'Preguntas frecuentes',
            description: 'Resolvemos tus dudas sobre el programa',
            image: 'https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/Preguntas+frecuentes.png',
            back: true
          } satisfies RouteHeader
        },
        loadComponent: () => import('@pages/faq-page/faq-page').then(c => c.FaqPage)
      },
      {
        path: 'tickets',
        loadChildren: () => import('@features/tickets/tickets.routes').then(m => m.routes)
      },
      {
        path: 'news',
        loadChildren: () => import('@features/news/news.routes').then(m => m.routes)
      },
      {
        path: 'register',
        canActivate: [hasRoleGuard([ROLES.EXECUTIVE])],
        loadChildren: () => import('@features/users/users.routes').then(m => m.routes)
      },
      {
        path: 'support',
        title: 'Canales de soporte',
        canActivate: [hasRoleGuard([ROLES.EXECUTIVE])],
        data: {
          header: {
            title: 'Canales de soporte',
            description: 'Elige el canal según tu consulta',
            image: 'https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/help-support.png',
            back: true
          } satisfies RouteHeader
        },
        loadComponent: () => import('@pages/support-page/support-page').then(c => c.SupportPage)
      },
      {
        path: 'tools',
        canActivate: [hasRoleGuard([ROLES.EXECUTIVE])],
        loadChildren: () => import('@pages/tool-page/tool.routes').then(m => m.routes)
      },
      {
        path: 'prizes',
        loadChildren: () => import('@features/prizes/prizes.routes').then(m => m.routes)
      }
    ]
  },
  {
    path: 'complete_signup',
    canActivate: [isAuthenticatedGuard],
    loadChildren: () => import('@features/auth/auth.routes').then(m => m.completeSignupRoutes)
  },
  {
    path: '',
    canActivate: [isNotAuthenticatedGuard],
    loadChildren: () => import('@features/auth/auth.routes').then(m => m.authRoutes)
  },
  {
    path: 'ui-kit',
    title: 'UI Kit',
    canActivate: [isAuthenticatedGuard],
    loadComponent: () => import('@pages/ui-kit-page/ui-kit-page').then(m => m.UiKitPage)
  },
  {
    path: '**',
    title: 'Página no encontrada',
    loadComponent: () => import('@pages/not-found-page/not-found-page').then(m => m.NotFoundPage)
  }
]
